// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ContentfulContext } from '@qld-recreational/contentful-library';

export const environment = {
  version: '2.0.0',
  buildNumber: '10000',
  production: false,
  targetEnv: 'mock',
  contentfulStagingHost: 'preview.contentful.com',
  contentfulProductionHost: 'cdn.contentful.com',
  contentfulSpace: '2qqca83da90n',
  contentfulContext: ContentfulContext.STAGING,
  contentfulStagingAccessToken: '1A9YwLzYeCYZNKtiNK_f3NXNa8ByzE1qxy15bKAdZ1E',
  contentfulProductionAccessToken:
    'vQ9lJDckDvPmb0qq4c5yXdNznhBigiBjXCv8s37Tils',
  oneSignalAppId: '659fe565-de71-436c-b274-ed7d18ef79a6',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
